export const QUERY__EVENTS = 'events';
export const QUERY__EVENT_INFINITE_LIST = 'event-infinite-list';
export const QUERY__EVENT = 'event';
